import {
  ArticleOutlined as ArticleOutlinedIcon,
  FeedOutlined as FeedOutlinedIcon,
  HomeOutlined as HomeOutlinedIcon,
  WorkOutlineOutlined as IconWorkOutlineOutlinedIcon,
  EmojiObjectsOutlined as EmojiObjectsOutlinedIcon,
  MiscellaneousServicesOutlined as MiscellaneousServicesOutlinedIcon,
  ListOutlined as ListOutlinedIcon,
  LayersOutlined as LayersOutlinedIcon,
  PolicyOutlined as PolicyOutlinedIcon,
  GavelOutlined as GavelOutlinedIcon,
} from '@mui/icons-material';

const pages = {
  id: 'groupc-pages',
  title: 'Pages',
  type: 'group',
  children: [
    {
      id: 'pages',
      title: 'Pages (SEO)',
      type: 'item',
      icon: ArticleOutlinedIcon,
      url: '/pages',
    },
    {
      id: 'home',
      title: 'Home Page',
      type: 'collapse',
      icon: HomeOutlinedIcon,
      children: [
        {
          id: 'home-sections',
          title: 'Sections',
          type: 'item',
          url: '/home-page-sections',
          icon: ListOutlinedIcon,
        },
        {
          id: 'services',
          title: 'Services',
          type: 'item',
          url: '/services',
          icon: MiscellaneousServicesOutlinedIcon,
        },
      ],
    },
    {
      id: 'internal-pages',
      title: 'Internal Pages',
      type: 'collapse',
      icon: LayersOutlinedIcon,
      children: [
        {
          id: 'information-pages',
          title: 'Information Pages',
          type: 'item',
          icon: FeedOutlinedIcon,
          url: '/information-pages',
        },
        {
          id: 'solutions',
          title: 'Solutions',
          type: 'item',
          url: '/solutions',
          icon: EmojiObjectsOutlinedIcon,
        },
        {
          id: 'group-articles',
          title: 'Articles',
          type: 'collapse',
          icon: ArticleOutlinedIcon,
          children: [
            {
              id: 'article-categories',
              title: 'Categories',
              type: 'item',
              url: '/article-categories',
            },
            {
              id: 'articles',
              title: 'Articles',
              type: 'item',
              url: '/articles',
            },
          ],
        },
        {
          id: 'vacancies',
          title: 'Vacancies',
          type: 'item',
          url: '/vacancies',
          icon: IconWorkOutlineOutlinedIcon,
        },
        {
          id: 'privacy-policy',
          title: 'Privacy Policy',
          type: 'item',
          url: '/privacy-policy',
          icon: PolicyOutlinedIcon,
        },
        {
          id: 'terms-conditions',
          title: 'Terms And Conditions',
          type: 'item',
          url: '/terms-conditions',
          icon: GavelOutlinedIcon,
        },
      ],
    },
  ],
};

export default pages;
